module.exports = " <footer id=footer> <p>{{getResource('FooterCompany')}} <a href=\"/Privacy Statement Ricoh MarCom Portal.pdf\" target=_blank> Privacy Statement</a> - <a href=static/cookie-policy/Index.html target=_blank> Cookie policy</a></p><p> </p><p>{{getResource('FooterSupport')}} <a href=mailto:marcom@ricoh-europe.com>marcom@ricoh-europe.com</a>.</p> </footer> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/site-footer/SiteFooter.vue
// module id = 171
// module chunks = 0